import { Card, Flex, Modal, Tag, Typography } from 'antd';
import styled from 'styled-components';

import { CheckCircleOutlined } from '@ant-design/icons';

export const DetailsLabel = styled(Typography.Text)`
  color: ${({ theme }) => theme.colorTextDescription};
`;

export const Wrapper = styled.div`
  .ant-modal-mask {
    background-color: transparent !important;
  }
`;

export const ModalStyled = styled(Modal).attrs({
  footer: null,
  mask: false,
  closeIcon: false,
})`
  margin-top: 48px;
  background: ${({ theme }) => theme.colorBgLayout};
  min-width: 100vw;
  top: 0;
  padding: 0;
  margin: 0 !important;
  .ant-modal-container {
    background: ${({ theme }) => theme.colorBgLayout};
    padding: 0;
    margin: 0;
    height: 100%;
    margin-top: var(--header-height);
    min-height: 100dvh;
  }
`;

interface HeaderTitleWrapperProps {
  $header?: boolean;
}

export const HeaderTitleWrapper = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
})<HeaderTitleWrapperProps>`
  padding-top: 16px;
  ${({ $header }) => $header && `width: 100%;`}
`;

export const ContentWrapper = styled.div`
  padding: 0 20px;
`;

interface StyledTagProps {
  $isGranted: boolean;
}

export const StyledTag = styled(Tag).attrs<StyledTagProps>(({ $isGranted }) => ({
  color: $isGranted ? 'success' : 'error',
  icon: <CheckCircleOutlined size={12} />,
}))`
  margin-bottom: 4px;
`;

export const TicketsLabel = styled(Typography.Title).attrs({
  level: 5,
})`
  margin: 12px 0;
  display: block;
`;

export const CardStyled = styled(Card).attrs({
  bordered: false,
})`
  margin-bottom: 16px;
`;

export const DetailsItemWrapper = styled(Flex)`
  margin-bottom: 4px;
`;

export const TicketsWrapper = styled.div`
  margin-bottom: 20px;
`;

export const DetailsWrapper = styled.div`
  svg {
    color: ${({ theme }) => theme.colorTextDescription};
    margin-right: 6px;
  }
`;
